export const isHeicOrHeif = (fileName: string): boolean => {
  const extension = fileName.match(/\.\w+$/);
  if (!extension) {
    return false;
  }
  return /\.(heic|heif)$/g.test(extension[0].toLowerCase());
};

export const isJPG = (fileName: string): boolean => {
  const extension = fileName.match(/\.\w+$/);
  if (!extension) {
    return false;
  }
  return /\.(jpg|jpeg)$/g.test(extension[0].toLowerCase());
};
